/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/* eslint-disable array-callback-return */
import React from 'react';
import PropTypes from 'prop-types';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Divider from '@material-ui/core/Divider';

import AddressHelper from './Helper/AddressHelper';
import PaymentMethod from './BillingDetail/PaymentMethod';
import OrderSummaryHelper from './Helper/OrderSummaryHelper';

class BillingDetail extends React.PureComponent {
    render() {
        const { orderDetailById } = this.props;

        if (orderDetailById.length < 1) return null;

        // console.log('orderDetailById', orderDetailById);

        const { billingDetail } = orderDetailById[0];

        if (!billingDetail) return null;

        const {
            cardNumber,
            cardType,
            thirdPartyType,
            giftCardPayments,
            billingPersonProfile: {
                firstName,
                lastName,
                businessName,
                address,
                phone,
                emailAddress,
            },
        } = billingDetail;

        return (
            <Card className="margin-top card-border-3 delivery-info">
                <CardContent>
                    <h2 className="gray-color no-margin-top">Billing Address</h2>
                    <div className="margin-bottom">
                        <div className="">
                            {firstName} {lastName}
                        </div>
                        {businessName ? <div>{businessName}</div> : ''}
                        <AddressHelper address={address} phone={phone} />
                        <div>{emailAddress}</div>
                    </div>
                    <Divider />
                    <PaymentMethod
                        data={{
                            cardNumber,
                            cardType,
                            thirdPartyType,
                            giftCardPayments,
                        }}
                    />
                    <Divider />
                    <h2 className="gray-color">Order Payment Summary</h2>
                    <OrderSummaryHelper
                        data={{
                            orderDetailById,
                            cardType,
                            cardNumber,
                            thirdPartyType,
                            giftCardPayments,
                        }}
                    />
                </CardContent>
            </Card>
        );
    }
}

BillingDetail.propTypes = {
    orderDetailById: PropTypes.array.isRequired,
};

export default BillingDetail;
